// extracted by mini-css-extract-plugin
export default {"default":"Container__default--mwubw","full-width":"Container__full-width--hM89d"};